<template>
  <q-card flat>
    <q-card-section
      class="q-pa-sm row justify-between items-center cp-btns location-info-box"
    >
      <strong>
        {{ label }} Details
        <span class="text-meta text-bold semi-bordered-bottom">
          ({{value.city}}, {{value.state}}, {{value.zipcode}})
        </span>
      </strong>
      <q-btn
        rounded
        dense
        color="brand5"
        label="Same as shipper"
        @click="$emit('clickSameAsShipper', value)"
        class="q-px-md"
      />
    </q-card-section>
    <q-card-section>
      <div>
        <label for="">{{label}} Contact *</label>
        <app-editable-input
          :data="value.name"
          name="name"
          @input="handleChangeInput"
          :error="validation.name.$error"
          outlined
          dense
          color="brand6"
        />
        <label for="">Phone *</label>
        <q-input
          type="tel"
          disablePhoneCall
          mask="+1 (###) ### - ####"
          unmasked-value
          name="phone"
          v-model="value.phone"
          :error="validation.phone.$error"
          outlined
          dense
          color="brand6"
        />
        <label for="">Street Address *</label>
        <app-editable-input
          :data="value.address"
          name="address"
          @input="handleChangeInput"
          :error="validation.address.$error"
          outlined
          dense
          color="brand6"
        />
        <label for="">Phone 2 (Optional)</label>
        <q-input
          v-model="value.phone2"
          type="tel"
          name="phone2"
          mask="+1 (###) ### - ####"
          unmasked-value
          outlined
          dense
          color="brand6"
        />
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import AppEditableInput from '@client/components/form/editable-input';

export default {
  name: 'AppBookOrderLocationInfo',
  props: {
    value: Object,
    label: String,
    validation: Object
  },
  components: {
    AppEditableInput
  },
  computed: {
    sectionClass() {
      if (this.$q.screen.lt.sm) return 'row q-col-gutter-sm';
      if (this.context === 'book') return 'row q-col-gutter-x-sm';
      return 'row q-col-gutter-sm';
    },
    sectionEditablePart() {
      return 'col-12 q-mb-md';
    },
    sectionStaticPart() {
      return 'col-12 static-info';
    }

  },
  methods: {

    handleChangeInput(value) {
      const { name, model } = value;
      this[name] = model;
      this.$emit('input', {
        ...this.value,
        [name]: model
      });
      if (this.validation[name]) {
        this.delayTouch(this.validation[name], this.$options.touchMap);
      }
    },
    // the mask triggers the watch
    // this functiolns controls so that the dirty is not set in initial load
    handlePhoneChangeInput(value, ov, name) {
      if (ov !== undefined && ov !== `+1${value}`) {
            this.$emit('input', {
              ...this.value,
              [name]: value
            });
          if (this.validation[name]) {
            this.delayTouch(this.validation[name], this.$options.touchMap);
          }
      }
    }

  },
  watch: {
      'value.phone': function (value, ov) {
        this.handlePhoneChangeInput(value, ov, 'phone');
      },
      'value.phone2': function (value, ov) {
        this.handlePhoneChangeInput(value, ov, 'phone2');
      }
  }
};
</script>
<style lang="scss">
  q-btn {
    font-size: 14px;
  }
  .cp-btns{
    row-gap:10px;
  }
  .location-info-box .text-meta {
    font-size: 13px;
  }
</style>
